export interface PagedResultDto<T> {
  totalCount: number;
  items: T[];
}

export interface PagedAndSortedResultRequestDto {
  skipCount?: number;
  maxResultCount?: number | undefined;
  sorting?: string;
}
